import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

const rootDiv = document.getElementById('root');

if (!rootDiv) {
  throw new Error('The Root element in index.html was not found. React cannot load.');
}

const root = createRoot(rootDiv);
root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
